"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiAssistantTypeEnum = void 0;
var AiAssistantTypeEnum;
(function (AiAssistantTypeEnum) {
    AiAssistantTypeEnum["QueueAssistant"] = "QueueAssistant";
    AiAssistantTypeEnum["OrganizationAssistant"] = "OrganizationAssistant";
})(AiAssistantTypeEnum = exports.AiAssistantTypeEnum || (exports.AiAssistantTypeEnum = {}));
